export interface UnusualNetworkMetrics {
  edgeName: string;
  interfaceName: string;
  timestamp: string;
  bandwidth: number;
  latency: number;
  jitter: number;
  packetloss: number;
  bucket: string;
  datausage: number;
  anomalies: string;
}

export enum SeverityLevel {
  Investigate = 'Investigate',
  Monitor = 'Monitor',
  Observe = 'Observe',
}

export interface DeviceEvent {
  device_name: string;
  date: string;
  begin_time: string;
  end_time: string;
  lead_count: number;
  summary: string;
  action_label: SeverityLevel;
}

export interface AccountDeviceData {
  account_name: string;
  devices: DeviceEvent[];
}
